function scrollToComment() {
  var hash = window.location.hash;
  var $comment = $('.tab-content').find(hash.toString());
  if ($comment.length) {
    var commentType = $comment.closest('.tab-pane').attr('id');
    $('a[href=#'+commentType+']').trigger('click');

    var commentOffset = $comment.offset().top;
    var headerHeight = $('.fixed-header').height();
    var scrollTo = commentOffset - 150;
    $(window).scrollTop(scrollTo);
  }
}

$(document).ready(function() {

  if ($('#reviews').length) {
    var $commentModal = $('#commentModal');

    $('.comment-reply-title').on('click', function() {
      $(this).hide();
      $('.comment-form').show();
    });

    $('.comment-respond .rating').on('click', function() {
      var $this = $(this);
      $(this).closest('.comment-respond .rating').removeClass('active');
      $this.addClass('active');
      $('input[name=rating]').val($this.data('value'));
    });

    $('.comment-respond input[name=first_name]').on('change', function() {
      var $this = $(this);
      var last_name = $this.closest('.comment-respond').find('input[name=last_name]').val();
      var author = $this.val() + ' ' + last_name;
      $this.closest('.comment-respond').find('input[name=author]').val(author);
    });

    $('.comment-respond input[name=last_name]').on('change', function() {
      var $this = $(this);
      var last_name = $this.closest('.comment-respond').find('input[name=first_name]').val();
      var author = $this.val() + ' ' + last_name;
      $this.closest('.comment-respond').find('input[name=author]').val(author);
    });

    $commentModal.find('#submit').on('submit', function(e) {
      e.preventDefault();
      var $form = $(this).closest('form');
      if ($form.find('input[name=email]').val() != $form.find('input[name=email_confirmation]').val()) {
        alert("Emails don't match");
      } else {
        if ($('input[name=rating]').length && !$form.find('.rating.active').length) {
          alert('Please rate the product');
        } else {
          $form.submit();
        }
      }
    });

    $('#questionform').on('submit', function(e) {
      e.preventDefault();
      var data = $(this).serializeArray();
      $.ajax({
        url: $(this).attr('action'),
        type: 'POST',
        dataType: 'json',
        data: data,
      })
      .done(function( response ) {
        if ( response.success ) {
          var url = window.location.href;
          if (url.indexOf('?') > -1) {
            url += '&question_submitted=1'
          } else {
            url += '?question_submitted=1'
          }
          window.location.href = url;
        } else {
          alert( response.errors );
        }
      });
      grecaptcha.reset();
    });

    $('.write-review').on('click', function() {
      $commentModal.find('#reviewTitle').show();
      $commentModal.find('#questionTitle').hide();
      $commentModal.find('.review-comment').show();
      $commentModal.find('.question-comment').hide();
      $commentModal.find('ol').hide();
      $commentModal.find('.comment-form-rating').show();
      $commentModal.find('.star-rating').show();
      $commentModal.find('.star-rating').append('<input type="hidden" name="rating" value="5" />');
    });

    scrollToComment();

    $(window).on('hashchange', function(e) {      
      e.preventDefault();
      scrollToComment();
    });
  }

});